import { createContext, useState, useEffect } from "react";
import useFetch from '../api/useFetch';

const NotificationsContext = createContext();

const NotificationsProvider = ({ children }) => {



  const [notifications, setNotifications] = useState({pending_orders: 0, late_orders_unprocessed: 0, total: 0})
  const [NotificationRefresh, setNotificationRefresh] = useState(false);


  let { result } = useFetch(`/martelle_notifications`, NotificationRefresh);

  useEffect(() => {
    setNotifications(result);
  }, [result]);

    useEffect(() => {
      const interval = setInterval(() => {
        setNotificationRefresh(!NotificationRefresh);
      }, 300000); // 5 minutes in milliseconds
  
      return () => clearInterval(interval);
    }, [NotificationRefresh]);

  return (
    <NotificationsContext.Provider value={{ notifications, NotificationRefresh, setNotificationRefresh}}>
      {children}
    </NotificationsContext.Provider>
  );
};

export { NotificationsContext, NotificationsProvider };
